import { Link } from 'react-router-dom';
import styles from './Home.module.css';
import { useTranslation } from 'react-i18next';
import langImg from '../../components/Navigation/languageImg.png';

export const Home = () => {
  const { t , i18n} = useTranslation();

  return (
    <div className={styles.home}>
      <button className={styles.langBtn+" "+styles['nav-link']}
          onClick={()=> i18n.changeLanguage(i18n.language === 'en' ? 'cs' : 'en')}
        >
            {i18n.language === 'en' ? 'EN' : 'CZ'} <img src={langImg} alt="" />
        </button>
      <div className={styles.container}>
        <h1 className={styles.title}>Ondřej <span>Wislocki</span></h1>
        <p className={styles.subtitle}>
          {t('home.subtitle')}
        </p>
        <nav className={styles.menu}>
          <Link to="/about" className={styles['menu-item']}>
            <span className={styles['menu-icon']}>👤</span>
            <span className={styles['menu-text']}>
              {t('home.about')}
            </span>
          </Link>
          <Link to="/projects" className={styles['menu-item']}>
            <span className={styles['menu-icon']}>💼</span>
            <span className={styles['menu-text']}>
              {t('home.projects')}
            </span>
          </Link>
          <Link to="/contact" className={styles['menu-item']}>
            <span className={styles['menu-icon']}>✉️</span>
            <span className={styles['menu-text']}>
              {t('home.contact')}
            </span>
          </Link>
          <Link to="/school-portfolio"  className={styles['menu-item']}>
            <span className={styles['menu-icon']}>🎓</span>
            <span className={styles['menu-text']}>
              {t('home.portfolio')}
            </span>
          </Link>
          <a href="https://github.com/Wisla-15/" target='_blank' rel="noreferrer" className={styles['menu-item']}>
            <span className={styles['menu-icon']}>💻</span>
            <span className={styles['menu-text']}>GitHub</span>
          </a>
          <a href="https://www.linkedin.com/in/ondřej-wislocki-8bba33394/" target='_blank' rel="noreferrer" className={styles['menu-item']}>
            <span className={styles['menu-icon']}>💼</span>
            <span className={styles['menu-text']}>LinkedIn</span>
          </a>
        </nav>
      </div>
    </div>
  );
};
